import moment from "moment"

const monthTickFormat = datum => moment(datum).format("MMM YYYY")
const dayTickFormat = datum => moment(datum).format("MMM DD")
const customMonthTickFormat = datum => moment(datum).format("MMM 'YY")
const timeTickFormat = datum => moment(datum).format("HH:mm")

function getOneDayTicks(min, max) {
  const diffInMinutes = moment(max).diff(moment(min), "minutes")
  if (diffInMinutes > 0 && diffInMinutes < 1440) {
    return [8, timeTickFormat]
  }
  return [1, dayTickFormat]
}

export const xAxisTicks = (min, max) => {
  const diff = moment(max).diff(moment(min), "days")

  if (diff <= 1) {
    return getOneDayTicks(min, max)
  } else if (diff <= 100) {
    return [5, dayTickFormat]
  } else if (diff <= 180) {
    return [5, monthTickFormat]
  }

  return [null, monthTickFormat]
}

export const xSmallAxisTicks = (min, max) => {
  const diff = moment(max).diff(moment(min), "days")

  if (diff <= 1) {
    return getOneDayTicks(min, max)
  } else if (diff <= 100) {
    return [5, dayTickFormat]
  }

  return [7, customMonthTickFormat]
}
